import { useMemo, useState } from "react"
import { Autocomplete, Stack, TextField } from "@mui/material"
import { skillMaps } from "routes/skill-mapper/controller/skill-maps"
import { skillMapLines } from "routes/skill-mapper/controller/skill-map-lines"

export function ConditionValueSkill({ value, onChange }) {
    const selected = Array.isArray(value) ? value : value ? [value] : []
    const [selectedMap, setSelectedMap] = useState(null)

    const mapsResult = skillMaps.useResults({ skip: 0, take: 100, status: "active" })
    const mapOptions = useMemo(getMapOptions, [mapsResult])

    const lines = skillMapLines.useResults(selectedMap ? { skillMapId: selectedMap.id } : null)
    const skillOptions = useMemo(getSkillOptions, [lines])

    return (
        <Stack spacing={1}>
            <Autocomplete
                options={mapOptions}
                getOptionLabel={getMapLabel}
                value={selectedMap}
                onChange={handleMapChange}
                renderInput={renderMapInput}
                isOptionEqualToValue={isOptionEqual}
            />
            <Autocomplete
                multiple
                freeSolo
                options={skillOptions}
                value={selected}
                onChange={handleChange}
                renderInput={renderSkillInput}
            />
        </Stack>
    )

    function getMapOptions() {
        return mapsResult?.items ?? []
    }

    function getMapLabel(option) {
        return option?.name || ""
    }

    function isOptionEqual(option, val) {
        return option?.id === val?.id
    }

    function getSkillOptions() {
        if (!lines) return []
        const names = new Set()
        for (const line of lines) {
            if (line.skillName) names.add(line.skillName)
        }
        return [...names].sort()
    }

    function handleMapChange(_, val) {
        setSelectedMap(val)
    }

    function handleChange(_, newValue) {
        onChange(newValue)
    }

    function renderMapInput(params) {
        return <TextField {...params} placeholder="Pick a skill map to browse skills..." />
    }

    function renderSkillInput(params) {
        return (
            <TextField
                {...params}
                placeholder={selectedMap ? "Select skills..." : "Pick a skill map first, or type skill names..."}
            />
        )
    }
}
